export default "__VITE_ASSET__CCBhyJ7D__"